import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { useProfile } from "@/context/ProfileContext";
import { PageLoader } from "@/components/auth/Guards";
import { ProfileHeader } from "@/components/profile/ProfileHeader";
import { ProfileStats } from "@/components/profile/ProfileStats";
import { FollowButton } from "@/components/profile/FollowButton";
import { UserAvatar } from "@/components/ui-nw/UserAvatar";
import { TrackList } from "@/components/music/TrackCard";
import { ProfileVideos } from "@/components/video/ProfileVideos";
import { PAGES } from "@/constants/testIds";

export default function PublicProfile() {
  const { username } = useParams();
  const { request } = useProfile();
  const [state, setState] = useState({ loading: true, profile: null, tracks: [] });

  useEffect(() => {
    setState({ loading: true, profile: null, tracks: [] });
    Promise.all([request("get", `/profiles/${username}`), request("get", `/profiles/${username}/tracks`)])
      .then(([profile, tracks]) => setState({ loading: false, profile, tracks }))
      .catch(() => setState({ loading: false, profile: null, tracks: [] }));
  }, [username, request]);

  if (state.loading) return <PageLoader />;
  if (!state.profile) return (
    <div data-testid={PAGES.notFound} className="py-24 text-center space-y-4">
      <h1 className="font-display text-4xl font-extrabold chrome-text">Profile not found</h1>
      <Link to="/" className="btn-red inline-block px-5 py-2.5 text-sm">Back home</Link>
    </div>
  );
  const p = state.profile;
  if (p.is_me) return <Navigate to="/profile" replace />;
  const isCreator = p.account_type === "creator";
  const onFollow = ({ is_following, followers }) =>
    setState((s) => ({ ...s, profile: { ...s.profile, is_following, stats: { ...s.profile.stats, followers } } }));

  return (
    <div data-testid={PAGES.publicProfile} className="space-y-6 animate-rise">
      <ProfileHeader profile={p} avatar={<UserAvatar profile={p} size="h-28 w-28 sm:h-32 sm:w-32" textSize="text-3xl" testId="public-profile-avatar" />}
        actions={isCreator && <FollowButton profile={p} onChange={onFollow} />} />
      <ProfileStats stats={p.stats} isCreator={isCreator} />
      {isCreator && (
        <section className="space-y-3">
          <h2 className="font-display text-xl font-bold text-white">Tracks</h2>
          <TrackList tracks={state.tracks} empty="No tracks released yet." />
        </section>
      )}
      {isCreator && <ProfileVideos username={p.username} />}
    </div>
  );
}
